import { UserProperties } from "@/types/models/UserProperties.interface";
const canViewGradingPage = (userProperties: UserProperties) => {
  const { isTeacher, isStudent } = userProperties;
  if (isStudent) return false;
  return isTeacher;
};

export default canViewGradingPage;
